    document.addEventListener('DOMContentLoaded', function() {
      var seen = {};
      document.querySelectorAll('link[rel="stylesheet"]').forEach(function(link) {
        var href = link.href;
        if (href.includes('font-awesome')) {
          if (seen[href]) {
            link.disabled = true;
          } else {
            seen[href] = true;
          }
        }
      });
    });

    // Resolve the issue of the [aria-*] attributes in the SEO report being missing valid values  (Product Details Page - jdgm-tab_product_reviews )
    (function () {
      // The selector for the tab button that needs to be monitored (the evaluation label generated by Judge.me)
      var TAB_SELECTOR = '.jdgm-tab[role="tab"]';

      function fixAriaControls(tabBtn) {
        var claimedId = tabBtn.getAttribute('aria-controls');
        if (!claimedId) return;

        var panel = document.getElementById(claimedId);

        if (panel) {
          // The panel exists and its ID has been matched. No further action is required.
          return;
        }

        // The panel does not exist: Try to find the element corresponding to the "looks like" panel through the button context.
        // The container class for the main interface of Judge.me is jdgm-tabpanel.
        var candidatePanel = document.querySelector(
          '.jdgm-tabpanel[data-tab-name="' + (tabBtn.dataset.tabName || '') + '"]'
        ) || document.querySelector('#jdgm-tabpanel_product_reviews, .jdgm-tabpanel');

        if (candidatePanel) {
          if (!candidatePanel.id) {
            candidatePanel.id = claimedId; // Add the ID to make it match.
          } else {
            tabBtn.setAttribute('aria-controls', candidatePanel.id); // Change the button to point to the actual ID
          }
        } else {
          // The panel has not been rendered yet. First, remove the invalid references to avoid errors reported by screen readers.
          tabBtn.removeAttribute('aria-controls');
          tabBtn.setAttribute('data-pending-aria-controls', claimedId); // Write it down. When the panel appears, go back and fill it in.
        }
      }

      function scanAndFix() {
        document.querySelectorAll(TAB_SELECTOR).forEach(function (tabBtn) {
          // Handling situations that were temporarily removed before and which may now have reappeared on the panel
          var pendingId = tabBtn.getAttribute('data-pending-aria-controls');
          if (pendingId && !tabBtn.getAttribute('aria-controls')) {
            var panel = document.getElementById(pendingId);
            if (panel) {
              tabBtn.setAttribute('aria-controls', pendingId);
              tabBtn.removeAttribute('data-pending-aria-controls');
              return;
            }
          }
          fixAriaControls(tabBtn);
        });
      }

      // Run it immediately after the page loads.
      document.addEventListener('DOMContentLoaded', scanAndFix);

      // Continuously monitor DOM changes (Judge.me is an asynchronous injected panel, and it might not be fully loaded upon initial loading)
      var observerJudge = new MutationObserver(function () {
        scanAndFix();
      });

      observerJudge.observe(document.documentElement, {
        childList: true,
        subtree: true
      });

      // Just to be safe, run it again after the window is loaded.
      window.addEventListener('load', scanAndFix);
    })();

    // Add the aria-label assignment - collection sidebar price slider
    function fixPriceSliderLabels() {
      document.querySelectorAll('.t4s-price_steps_slider .noUi-handle-lower').forEach(function (el) {
        if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'Lowest price');
      });
      document.querySelectorAll('.t4s-price_steps_slider .noUi-handle-upper').forEach(function (el) {
        if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'Highest price');
      });
    }

    document.addEventListener('DOMContentLoaded', fixPriceSliderLabels);

    var observerSlider = new MutationObserver(fixPriceSliderLabels);
    observerSlider.observe(document.documentElement, { childList: true, subtree: true });    

    // [aria-hidden="true"] The element contains focusable sub-elements
    (function () {
      function fixFlickityFocusable() {
        // Hidden slide: Set the internal focusable elements as non-focusable
        document.querySelectorAll('.t4s-flicky-slider .t4s-col-item[aria-hidden="true"]').forEach(function (cell) {
          var focusableEls = cell.querySelectorAll('a, button, input, [tabindex]');
          focusableEls.forEach(function (el) {
            if (el.getAttribute('tabindex') !== '-1') {
              el.setAttribute('tabindex', '-1');
            }
          });
        });

        // Visible slide: Internal focusable elements regain focusability
        document.querySelectorAll('.t4s-flicky-slider .t4s-col-item:not([aria-hidden="true"])').forEach(function (cell) {
          var focusableEls = cell.querySelectorAll('a, button, input, [tabindex="-1"]');
          focusableEls.forEach(function (el) {
            el.setAttribute('tabindex', '0');
          });
        });
      }

      // Run it once after the page is fully loaded.
      document.addEventListener('DOMContentLoaded', fixFlickityFocusable);
      window.addEventListener('load', fixFlickityFocusable);

      // Continuously monitor DOM changes: new nodes inserted (e.g. async-loaded carousels),
      // as well as aria-hidden attribute changes (e.g. when Flickity switches slides)
      var observerFlick = new MutationObserver(fixFlickityFocusable);
      observerFlick.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    })();

    //The format of the accessibility feature tree for the plugin is incorrect. - ga-carousel
    function fixA11y(root = document) {
        // Carousel prev/next buttons
        root.querySelectorAll('.ga-carousel_wrapper button.gowl-prev, .ga-carousel_wrapper button.gowl-next')
            .forEach(btn => {
            if (btn.getAttribute('role') === 'presentation') {
                btn.removeAttribute('role');
            }
            if (!btn.textContent.trim() && !btn.getAttribute('aria-label')) {
                btn.setAttribute('aria-label', btn.classList.contains('gowl-prev') ? 'Prev' : 'Next');
            }
            });

        // Package radio
        root.querySelectorAll('.rbu-qb-tier-header input[type="radio"]').forEach(input => {
            if (!input.getAttribute('aria-label') && !input.labels?.length) {
            input.setAttribute('aria-label', 'Select a package');
            }
        });

        // Evaluation link
        root.querySelectorAll('a.t4s-product__review').forEach(a => {
            if (!a.textContent.trim() && !a.getAttribute('aria-label')) {
            a.setAttribute('aria-label', 'View product reviews');
            }
        });

        // Judge.me evaluation for tab: Add role=tablist to the parent container
        root.querySelectorAll('[role="tab"]').forEach(tab => {
            const list = tab.parentElement;
            if (list && list.getAttribute('role') !== 'tablist') {
            list.setAttribute('role', 'tablist');
            }
        });
    }

    // First execution
    fixA11y();
    console.log('a11y patch loaded');

    // Key change: Simultaneously monitor changes in child nodes and attributes. When Vue re-renders, it can also reapply patches.
    const a11yObserver = new MutationObserver((mutations) => {
        fixA11y();
    });
    a11yObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['role', 'aria-label', 'aria-selected']
    });    

